import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const MEETING_URL = process.env.REACT_APP_HUBSPOT_MEETING_LINK_URL;

export default function TopBar() {
  return (
    <div
      data-testid="top-bar"
      className="fixed top-0 inset-x-0 z-[60] bg-navy text-white text-xs"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-between gap-3">
        <div className="hidden sm:flex items-center gap-2 text-white/75">
          <span className="h-1.5 w-1.5 rounded-full bg-teal2 animate-pulse" />
          <span className="tracking-wide">For licensed eye care professionals · United States</span>
        </div>
        <div className="flex items-center gap-4 sm:gap-5">
          <a
            href="https://www.oculusbiologics.com/support/order/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("order_xcellereyes_click", { location: "topbar" })}
            data-testid="topbar-cta-order"
            className="group inline-flex items-center gap-1.5 font-semibold text-white/85 hover:text-teal2 transition-colors whitespace-nowrap"
          >
            <span>Order XcellerEYES</span>
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </a>
          <span className="hidden sm:inline text-white/20">|</span>
          {MEETING_URL ? (
            <a
              href={MEETING_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("request_demo_click", { location: "topbar" })}
              data-testid="topbar-cta-demo"
              className="group inline-flex items-center gap-1.5 font-semibold text-teal2 hover:text-white transition-colors whitespace-nowrap"
            >
              <Phone className="h-3.5 w-3.5" />
              <span>Request a Demo</span>
              <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
            </a>
          ) : (
            <Link
              to="/contact"
              onClick={() => trackEvent("request_demo_click", { location: "topbar" })}
              data-testid="topbar-cta-demo"
              className="group inline-flex items-center gap-1.5 font-semibold text-teal2 hover:text-white transition-colors whitespace-nowrap"
            >
              <Phone className="h-3.5 w-3.5" />
              <span>Request a Demo</span>
              <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
